// extracted by mini-css-extract-plugin
export default {"graphFactPanelEntry":"Ii05s73","collapsibleItemLvl2":"pU3seV_"};